module.exports = __webpack_public_path__ + "static/dl1-screen1-4aae20eb9dd926f900db826715126566.png";